// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ProxReceiptStatus } from './prox-receipt-status';
import { ProxReceiptStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProxReceipt extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** DateTimeOffset */
  crtnTs!: Date;
  /** String(50) */
  entityId1!: string;
  /** String(50) */
  entityId2!: string;
  /** String */
  error?: string;
  /** Enum FK proxReceiptStatus */
  proxReceiptStatusId!: ProxReceiptStatusEnum;
  /** String */
  rawPayload?: string;
  /** String(50) */
  resolvedEntityId?: string;
  /** String(50) */
  tableName!: string;
  /** FK proxReceiptStatusId */
  proxReceiptStatus!: ProxReceiptStatus;
}

